import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Injector,
  Input, OnChanges,
  OnDestroy,
  OnInit, SimpleChanges,
  ViewChild
} from '@angular/core'
import {
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  FormControlDirective,
  NG_VALUE_ACCESSOR
} from '@angular/forms'
import {TranslateService} from "@ngx-translate/core";
import {
  MultiSelectWithStaticOptionsStaticComponent
} from "../multi-select-static-with-static-options/multi-select-with-static-options-static.component";
import {SelectOption} from "../form-group/form-group.component";
import {distinctUntilChanged, Subject, takeUntil} from "rxjs";


@Component({
    selector: 'app-multi-select-enum[enum]',
    templateUrl: './multi-select-enum.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useClass: MultiSelectEnumComponent,
            multi: true
        }],
  imports: [MultiSelectWithStaticOptionsStaticComponent],
    standalone: true
})
export class MultiSelectEnumComponent implements ControlValueAccessor , OnInit, OnDestroy, OnChanges {

  @Input() public label!: string
  @Input() public small = false
  @Input() public inline = false
  @Input() public errorMessages!: Record<string, string>
  @Input() public name!: string
  @Input() public prefix?: string
  @Input() public enum?: Record<string, string>
  @Input() public omitValues?: string[];
  @Input() public translateKey?: string
  @Input() public sortByDisplayValue: boolean = true;
  public selectOptions: SelectOption[] = []

  private getTranslatedOptions():void {
    const options: { key: string, value: string }[] = [];
    const filteredEnum: Record<string, string> = {};
    Object.entries(this.enum ?? []).filter(x => !this.omitValues?.includes(x[1])).forEach(x => {
      filteredEnum[x[0]] = x[1];
    });
    for (const key in filteredEnum) {
      if (filteredEnum[key] && typeof filteredEnum[key] === 'string') {
        const translationKey = 'enums.' + this.translateKey + '.' + filteredEnum[key];
        const translatedValue = this.translate.instant(translationKey);
        options.push({ value: translatedValue, key: filteredEnum[key] });
      }
    }
    if(this.sortByDisplayValue) options.sort((a,b) => a.value.localeCompare(b.value))
    this.selectOptions = [...options];
  }

  @Input() public multi = true


  @Input() public placeholder?: string;

  @ViewChild(FormControlDirective, {static: true})
  public formControlDirective?: FormControlDirective;

  @Input()
  public formControl?: FormControl<string[] | string | null>

  @Input()
  public formControlName?: string;

  private onDestroy$: Subject<void> = new Subject<void>();

  public get control(): FormControl<string[] | string | null> {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return <FormControl<string[] | string | null>>this.formControl ?? this.controlContainer?.control?.get(this.formControlName);
  }

  get controlContainer(): ControlContainer {
    return this.injector.get(ControlContainer);
  }

  registerOnTouched(fn: () => void): void {
    this.formControlDirective?.valueAccessor?.registerOnTouched(fn);
  }

  registerOnChange(fn: () => void): void {
    this.formControlDirective?.valueAccessor?.registerOnChange(fn);
  }

  writeValue(obj: string[] | string | null): void {

    this.formControlDirective?.valueAccessor?.writeValue(obj);
  }

  setDisabledState(): void {
    // da formControl und control identisch sind brauchen wir hier nichts weiter zu geben

  }

  constructor(private readonly cdr: ChangeDetectorRef, private readonly injector: Injector, private translate: TranslateService) {
  }

  public ngOnInit(): void {
    this.getTranslatedOptions();
    this.translate.onLangChange.pipe(
      distinctUntilChanged(),
      takeUntil(this.onDestroy$)
    ).subscribe(() => {
      this.getTranslatedOptions()
      this.cdr.markForCheck();
    })
  }

  public ngOnChanges(changes: SimpleChanges) {
    if('enum' in changes && changes['enum'].currentValue !== changes['enum'].previousValue) this.getTranslatedOptions();
  }

  public ngOnDestroy() {
    this.onDestroy$.next();
  }
}
